module.exports = __webpack_public_path__ + "index_pc/img/icon_qq.766017a2.png";